import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import FieldCategory from '../../Fields/Category';
import ServiceName from '../../Fields/ServiceName';
import FieldOverflow from '../../Fields/Overflow';
import FieldIncrement from '../../Fields/Increment';
import FieldDenyLinksDuplicate from '../../Fields/DenyLinkDuplicates';
import FieldRate from '../../Fields/Rate';
import FieldMinMax from '../../Fields/MinMax';
import FieldMode from '../../Fields/Mode';
import FieldSubscription from '../../Fields/Subscription';
import FieldsWrapper from '../../components/FieldsWrapper';
import SwitchFields from '../../components/SwitchFields';
import FieldsOptions from '../../components/FieldsOptions';
import FieldsRefill from '../../components/FieldsRefill';
import FieldStartCountParsing from '../../Fields/StartCountParsing';
import FieldAutoComplete from '../../Fields/AutoComplete';
import FieldStatusSync from '../../Fields/StatusSync';
import GroupWalls from '../../../../../../../../components/GroupWalls';

import accessFields from './access';
import { getOptionIcon } from '../../../../../helpers/getters';

const WrapperAccessFields = ({ modal, serviceData, dispatchServiceData }) => {
  const { config } = useSelector((state) => state.services);

  const showServiceName = accessFields.serviceName(serviceData);
  const showCategory = accessFields.category(serviceData);
  const showSubscription = accessFields.subscription(modal);
  const showMinMax = accessFields.minmax(serviceData);
  const showSyncStatus = accessFields.syncStatus(serviceData);
  const showDenyLinkDuplicates = accessFields.denyLinkDuplicates(serviceData, modal);
  const showIncrement = accessFields.increment(serviceData, modal);
  const showOverflow = accessFields.overflow(serviceData, modal);
  const showStartCountParsing = accessFields.startCountParsing(serviceData, modal, config);
  const showAutoComplete = accessFields.autoComplete(serviceData, modal, config);
  const showRefill = accessFields.refill(serviceData, modal, config);

  const showGroupsWalls = [showStartCountParsing, showAutoComplete, showRefill].some((item) => item);

  const isStartCountParsingActive = serviceData?.form?.start_count !== 0;
  const isAutoCompleteActive = serviceData?.form?.auto_complete;
  const isRefillActive = serviceData?.form?.refill?.refill_type !== 0;

  const iconRefill = useMemo(() => getOptionIcon('refill'), []);
  const iconStartCount = useMemo(() => getOptionIcon('start_count'), []);
  const iconAutoComplete = useMemo(() => getOptionIcon('auto_complete'), []);

  return (
    <>
      {showServiceName ? <ServiceName dispatchServiceData={dispatchServiceData} {...serviceData} /> : null}
      {showCategory ? <FieldCategory dispatchServiceData={dispatchServiceData} {...serviceData} /> : null}
      {showSubscription ? <FieldSubscription dispatchServiceData={dispatchServiceData} modal={modal} {...serviceData} /> : null}
      <FieldsWrapper>
        <FieldMode dispatchServiceData={dispatchServiceData} modal={modal} {...serviceData} />
        <SwitchFields dispatchServiceData={dispatchServiceData} modal={modal} {...serviceData} />
        <FieldsOptions dispatchServiceData={dispatchServiceData} modal={modal} {...serviceData} />
      </FieldsWrapper>
      <FieldRate dispatchServiceData={dispatchServiceData} {...serviceData} modal={modal} />
      {showMinMax ? <FieldMinMax dispatchServiceData={dispatchServiceData} {...serviceData} /> : null}
      {showSyncStatus ? <FieldStatusSync dispatchServiceData={dispatchServiceData} {...serviceData} /> : null}
      {showDenyLinkDuplicates ? <FieldDenyLinksDuplicate dispatchServiceData={dispatchServiceData} {...serviceData} /> : null}
      {showIncrement ? <FieldIncrement dispatchServiceData={dispatchServiceData} {...serviceData} /> : null}
      {showOverflow ? <FieldOverflow dispatchServiceData={dispatchServiceData} {...serviceData} /> : null}
      {showGroupsWalls ? (
        <GroupWalls.Wrapper>
          {showStartCountParsing ? (
            <GroupWalls.Item active={isStartCountParsingActive}>
              <FieldStartCountParsing dispatchServiceData={dispatchServiceData} {...serviceData} />
              <GroupWalls.Icon>
                <span className={iconStartCount.className} />
              </GroupWalls.Icon>
            </GroupWalls.Item>
          ) : null}
          {showAutoComplete ? (
            <GroupWalls.Item active={isAutoCompleteActive}>
              <FieldAutoComplete dispatchServiceData={dispatchServiceData} {...serviceData} modal={modal} />
              <GroupWalls.Icon>
                <span className={iconAutoComplete.className} />
              </GroupWalls.Icon>
            </GroupWalls.Item>
          ) : null}
          {showRefill ? (
            <GroupWalls.Item active={isRefillActive}>
              <FieldsRefill dispatchServiceData={dispatchServiceData} {...serviceData} />
              <GroupWalls.Icon>
                <span className={iconRefill.className} />
              </GroupWalls.Icon>
            </GroupWalls.Item>
          ) : null}
        </GroupWalls.Wrapper>
      ) : null}
    </>
  );
};

WrapperAccessFields.propTypes = {
  modal: PropTypes.object,
  serviceData: PropTypes.object,
  dispatchServiceData: PropTypes.func,
}

export default WrapperAccessFields;
